import { render, staticRenderFns } from "./NewsPdfViewer.vue?vue&type=template&id=7ac2c2ef&scoped=true"
import script from "./NewsPdfViewer.vue?vue&type=script&lang=js"
export * from "./NewsPdfViewer.vue?vue&type=script&lang=js"
import style0 from "./NewsPdfViewer.vue?vue&type=style&index=0&id=7ac2c2ef&lang=css"
import style1 from "./NewsPdfViewer.vue?vue&type=style&index=1&id=7ac2c2ef&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac2c2ef",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tomi/Projects/ingeniAR/rrhh/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ac2c2ef')) {
      api.createRecord('7ac2c2ef', component.options)
    } else {
      api.reload('7ac2c2ef', component.options)
    }
    module.hot.accept("./NewsPdfViewer.vue?vue&type=template&id=7ac2c2ef&scoped=true", function () {
      api.rerender('7ac2c2ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/News/NewsPdfViewer.vue"
export default component.exports